export const resolveTabsUrlHash = (arr, defaultValue) => {
    return arr?.find((v) => [`#${v}`, `#${v?.value}`].includes(window.location?.hash)) ?? defaultValue;
};

export const resolveTabsIndexUrlHash = (arr, defaultIndex) => {
    const resIndex = arr?.findIndex((v) => [`#${v}`, `#${v?.value}`].includes(window.location?.hash));
    return ~resIndex ? resIndex : defaultIndex;
};
